import React, {useState} from 'react';

import DomainTablePage from '../../components/domainTablePage.js'
import { IPWebsitesResult } from '../../../../server/routes/ip.js'


interface IPWebsitesProps {
	server: string;
	pageData: unknown;
}

export default function IPWebsites({server, pageData}: IPWebsitesProps) {

	const typedPageData = pageData as IPWebsitesResult;
	let [data, setData] = useState(typedPageData);

	return (
        <DomainTablePage 
            domainList={data.TechnologyDomains}
        />
	)
}
